<template>
  <div class="menuBody" style="margin-left:25px;">
    <div class="menuTool" style="width:100%;">
         <InspectionStandardDialog  @dialogVisible="dialog" ref="InspectionStandardDialog"/>
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                巡检标准列表
              <div style="float:right;margin-right:10px;margin-top:-10px">
               <el-button type="primary"  size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" @click="PropertyAdd()">巡检标准添加</el-button>
            </div>
            </div>
               <div style="width:150px;float:left;margin-right:15px">
                <el-select  clearable v-model="value" size="small"  @change="classificationChange(value)" placeholder="请选择巡检分类">
                    <el-option
                    v-for="item in classificationList"
                    :key="item.id"
                    :label="item.typeName"
                    :value="item.id">
                    </el-option>
                </el-select>
              </div>
             <div style="float:right;margin-right:15px;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" @click="Inquire()">查询</el-button>
            </div>
    <el-table  :data="tableData" tooltip-effect="light"   v-loading="loading"    style="margin-bottom: 20px;overflow-y: scroll;float:right;margin-top:30px" row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
        <el-table-column show-overflow-tooltip prop="inspectType" label="巡检分类"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="field" label="所属系统"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="spotType" label="点位类型" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="inspectStandard" label="正向巡检标准" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="inspectStandardEx" label="负向巡检标准" ></el-table-column>
        <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
            <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" title="修改"></el-button>
            <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" title="删除"  v-debounce></el-button>
            </template>
        </el-table-column>
    </el-table>
          <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import InspectionStandardDialog from '../pollingCommon/InspectionStandardDialog.vue'
export default {
  name: "InspectionStandard",
  components: {InspectionStandardDialog},
  data() {
    return {
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        loading:false,
        classifyName:"",
        tableData:[],
        classificationList:[{
            "value":"1",
            "label":"工程巡检"
        }],
        value:"",
        inspectTypeName:"",


        SubordinateList:[],

    }
  },
  methods: {
    handleSizeChange(val) {
        this.pagesize  = val
        this.InitialQuery()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.InitialQuery()
    },
    dialog(data){
      if(data==false){
        this.InitialQuery()
      }
    },
    InitialQuery(){
    // 列表
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "inspectType":"",
      }
      this.$http.post(this.$requestUrl.POST_STAND_LIST,PageSize).then((res) => {
      let data = res.data
      if(data.code == 200){
        this.tableData = data.data.records
        this.total = data.data.total
      }else{
        this.$message.error(data.msg)
      }
    }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
    })
    },
    PropertyAdd(){
    // 添加
        let obj = {}
        this.$refs.InspectionStandardDialog.title = "添加巡检标准";
        this.$refs.InspectionStandardDialog.dialogVisible = true;
        this.$refs.InspectionStandardDialog.formLabelAlign = obj
        this.$refs.InspectionStandardDialog.SubordinateList = this.SubordinateList
        this.$refs.InspectionStandardDialog.ClassifyNameList = this.classificationList
    },
    editMenu(row){
    // 修改
        this.$refs.InspectionStandardDialog.title = "修改巡检标准";
        this.$refs.InspectionStandardDialog.dialogVisible = true;
        this.$refs.InspectionStandardDialog.ForwardText = row.inspectStandard
        this.$refs.InspectionStandardDialog.ReverseText = row.inspectStandardEx
        this.$refs.InspectionStandardDialog.value = row.field
        this.$refs.InspectionStandardDialog.rowId = row.id
        this.$refs.InspectionStandardDialog.PointTypevalue = row.spotType
        this.$refs.InspectionStandardDialog.ClassifyNamevalue = row.inspectType
        this.$refs.InspectionStandardDialog.ClassifyNameList = this.classificationList
        this.$refs.InspectionStandardDialog.SubordinateList = this.SubordinateList
    },
    delMenu(row){
    // 删除
          this.$confirm('是否确认要删除该标准?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.get(this.$requestUrl.DELETE_GET_STAND+row.id).then((res) => {
          let data = res.data
          if(data.code == 200){
            this.currentPage = 1
            this.InitialQuery()
            }else{
              this.$message.error(data.msg)
            }
            })
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    Inquire(){
    // 查询
    let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "inspectType":this.inspectTypeName,
      }
      this.$http.post(this.$requestUrl.POST_STAND_LIST,PageSize).then((res) => {
      let data = res.data
      if(data.code == 200){
        this.tableData = data.data.records
        this.total = data.data.total
      }else{
         this.$message.error(data.msg)
      }
    }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
    })
    },
    classificationChange(res){
      for(let val of this.classificationList){
        if(val.id == res){
          this.inspectTypeName = val.typeName
        }
      }
    },
    classification(){
      this.$http.get("/inspect/type/select").then((res)=>{
      let data = res.data
      if(data.code == 200){
        this.classificationList = res.data.data
      }else{
         this.$message.error(data.msg)
      }
      })
    },
    Subordinate(){
      this.$http.get("/inspect/stand/getAllSystem").then((res)=>{
      let data = res.data
      let arr =[]
      if(data.code == 200){
        for(let i = 0;i<data.data.length;i++){
          let obj = {
            "value":i,
            "label":data.data[i]
          }
          arr.push(obj)
        }
        this.SubordinateList = arr
      }else{
         this.$message.error(data.msg)
      }
      })
    },





  },
  mounted() {
    this.Subordinate()
    this.classification()
    this.InitialQuery()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
</style>